import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DEFAULT_DASHBOARD_USER } from '../../dashboard/dashboard.data';
import { DashboardHeaderComponent } from '../header/header';
import { DashboardSidebarComponent } from '../sidebar/sidebar';

@Component({
  selector: 'app-report-shell',
  standalone: true,
  imports: [CommonModule, DashboardSidebarComponent, DashboardHeaderComponent],
  templateUrl: './report-shell.html',
  styleUrl: './report-shell.scss',
})
export class ReportShellComponent {
  @Input() user = DEFAULT_DASHBOARD_USER;
  @Input() currentTime = '';
  @Input() sidebarCollapsed = false;
  @Input() mobileSidebarOpen = false;

  @Output() menuToggle = new EventEmitter<void>();
  @Output() closeMobileSidebar = new EventEmitter<void>();
}
